<template>
  <div class="FinancesPayoutsTaxesTable finances-invoices-table">
    <PanelHeader title="Taxes" :isOpen="show" :onToggleButtonClick="togglePanel" />

    <b-collapse
      class="mx-3"
      v-model="show"
    >
      <b-table :fields="fields" :items="items" borderless>
        <template #cell(amount)="{ item, index }">
          <CostInput
            v-model="item.amount"
            :currencyCode="currencyCode"
            :tooltip="item.is_manually_edit ? 'Manually edited amount. For auto calculation click checkbox' : 'Auto calculated amount'"
            @input="editAmount(item)"
          />
        </template>
        <template #cell(is_manually_edit)="{ item, index }">
          <div class="edit-type-switch-container">
            <b-form-checkbox
              size="sm"
              switch
              v-model="item.is_manually_edit"
              class="switch"
              v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }"
              :title="item.is_manually_edit ? 'Auto calculation' : 'Fix taxes'"
              @change="() => handleIsManuallyEditSwitchChange(item)"
            />
          </div>
        </template>
        <template #cell(tax_type)="{ item, index }">
          <div> {{ item.tax_type.tax_type_name }}</div>
        </template>
        <template #cell(user)="{ item, index }">
          <div> {{ item.user.name }}</div>
        </template>
        <template #cell(description)="{ item, index }">
          <b-form-textarea
            id="textarea"
            v-model="item.description"
            rows="2"
            max-rows="6"
            @input="() => handleItemDescriptionChange(item)"
          >
          </b-form-textarea>
        </template>
      </b-table>
    </b-collapse>
  </div>
</template>

<script>
import PanelHeader from '@components/invoices/form/PanelHeader.vue'
import CostInput from '@components/invoices/form/CostInput.vue'

export default {
  components: { CostInput, PanelHeader },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    /**
     * $vModel is a vuelidate copy of the passed to the component. We need it to correctly track user input to validate
     * data and mark fields as dirty.
     */
    $vModel: Object,
    currencyCode: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      show: true,
      fields: [
        { key: 'tax_type', label: 'Tax type', class: 'name-column' },
        { key: 'user', label: 'Contractor', class: 'name-column' },
        { key: 'amount', label: 'Amount', class: 'amount-column' },
        { key: 'is_manually_edit', label: 'Manually', class: 'edit-type-column' },
        { key: 'description', label: 'Description', class: 'description-column' }
      ],
      items: []
    }
  },
  mounted () {
    this.setInitialParams()
  },
  watch: {
    'value': {
      deep: true,
      handler () {
        this.setInitialParams()
      }
    }
  },
  methods: {
    togglePanel () {
      this.show = !this.show
    },
    setInitialParams () {
      this.items = this.value || []
      this.triggerInputEmit()
    },
    triggerInputEmit () {
      this.$emit('input', this.items)
    },
    calculatePayout () {
      this.$emit('calculatePayout')
    },
    editAmount (item) {
      item.is_manually_edit = true
      this.$vModel.$touch()
      this.calculatePayout()
    },
    handleIsManuallyEditSwitchChange (item) {
      if (!item.is_manually_edit) {
        this.calculatePayout()
      }
      this.$vModel.$touch()
    },
    handleItemDescriptionChange (item) {
      item.is_manually_edit = true
      this.$vModel.$touch()
    }
  }
}
</script>

<style lang="scss" scoped>
.FinancesPayoutsTaxesTable{
  :global(td.name-column) {
    padding-top: 8px;
  }

  :global(.amount-column) {
    width: 10%;
    min-width: 110px;
  }

  :global(.edit-type-column) {
    text-align: center;
  }
}

.edit-type-switch-container {
  position: relative;
  top: 6px;
  display: inline-block;
}
</style>
